import React, { useState } from "react";
import { db } from "../services/firebase";
import {
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

const ADMIN_EMAIL = "haicokuut@gmail.com"; // 🔐 change if needed
const ADMIN_PASS = "teamscan2025";         // 🔐 change if needed

export default function VoucherCreator() {
  const [authPassed, setAuthPassed] = useState(false);
  const [inputEmail, setInputEmail] = useState("");
  const [inputPass, setInputPass] = useState("");

  const [code, setCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [expiresAt, setExpiresAt] = useState("");
  const [isSingleUse, setIsSingleUse] = useState(true);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleCreateVoucher = async () => {
    setError("");
    setSuccessMessage("");

    if (!code || discount <= 0 || discount > 100) {
      setError("Please enter a valid code and discount (1–100%).");
      return;
    }

    try {
      // 🔍 Check for duplicates
      const existingQuery = query(
        collection(db, "vouchers"),
        where("code", "==", code.trim())
      );
      const existingSnap = await getDocs(existingQuery);
      if (!existingSnap.empty) {
        setError("❌ This voucher code already exists.");
        return;
      }

      // ✅ Call secure API
      await fetch("/api/createVoucher", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-admin-key": "teamscan2025",
        },
        body: JSON.stringify({ code, discount, expiresAt, isSingleUse }),
      });

      setSuccessMessage("✅ Voucher created successfully.");
      setCode("");
      setDiscount(0);
      setExpiresAt("");
      setIsSingleUse(true);

    } catch (err) {
      console.error("Error creating voucher:", err);
      setError("❌ Failed to create voucher.");
    }
  };

  // 🔐 Basic Access Gate
  if (!authPassed) {
    return (
      <div style={{ padding: "2rem", maxWidth: "400px", margin: "0 auto" }}>
        <h2>🔒 Admin Access Required</h2>
        <input
          type="email"
          placeholder="Email"
          value={inputEmail}
          onChange={(e) => setInputEmail(e.target.value)}
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />
        <input
          type="password"
          placeholder="Passphrase"
          value={inputPass}
          onChange={(e) => setInputPass(e.target.value)}
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />
        <button
          onClick={() => {
            if (inputEmail === ADMIN_EMAIL && inputPass === ADMIN_PASS) {
              setAuthPassed(true);
            } else {
              alert("Invalid credentials.");
            }
          }}
          style={{
            padding: "0.5rem 1rem",
            backgroundColor: "#0070f3",
            color: "white",
            border: "none",
            borderRadius: "4px",
          }}
        >
          Log in
        </button>
      </div>
    );
  }

  // 🧾 Voucher Form UI
  return (
    <div style={{ maxWidth: "500px", margin: "2rem auto", padding: "1rem" }}>
      <h2>Create New Voucher</h2>
      <label>Voucher Code:</label>
      <input
        type="text"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
      />

      <label>Discount (%):</label>
      <input
        type="number"
        value={discount}
        onChange={(e) => setDiscount(parseInt(e.target.value))}
        style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
      />

      <label>Expiration Date (optional):</label>
      <input
        type="date"
        value={expiresAt}
        onChange={(e) => setExpiresAt(e.target.value)}
        style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
      />

      <label>
        <input
          type="checkbox"
          checked={isSingleUse}
          onChange={(e) => setIsSingleUse(e.target.checked)}
        />{" "}
        One-time use only
      </label>

      <div style={{ marginTop: "1rem" }}>
        <button
          onClick={handleCreateVoucher}
          style={{
            padding: "0.5rem 1rem",
            backgroundColor: "#0070f3",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Create Voucher
        </button>
      </div>

      {error && <p style={{ color: "red", marginTop: "1rem" }}>{error}</p>}
      {successMessage && (
        <p style={{ color: "green", marginTop: "1rem" }}>{successMessage}</p>
      )}
    </div>
  );
}
